import { Field } from '../types/fields';
import { FormConfig } from '@topdanmark-onlinesolutions/claim-form-types';

// NOTE:
// This will give you the *last*
// instance of an element in case there are more than one
// It is only intended for *single use* element types
// like uploadDocumentatin
export const getElementFromElementType = (
    formConfig: FormConfig | undefined,
    elementType: string
): undefined | Field => {
    if (!formConfig) {
        return;
    }

    let element = undefined;
    formConfig.pages.forEach((page) => {
        const elementUnderTest = page.elements.find((element) => element.type === elementType);
        if (elementUnderTest) {
            element = elementUnderTest;
        }
    });

    return element;
};
